import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CustomFormPageRoutingModule } from './custom-form-routing.module';

import { CustomFormPage } from './custom-form.page';
import { FormioModule } from 'angular-formio';
import { MasterHeaderModule } from '../master-header/master-header.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FormioModule,
    MasterHeaderModule,
    CustomFormPageRoutingModule
  ],
  declarations: [CustomFormPage]
})
export class CustomFormPageModule {}
